import React, { useState } from 'react'
import styles from "./settings.module.css"
import { BsFunnel } from 'react-icons/bs'
import { LuTextCursorInput } from 'react-icons/lu'
import { MdOutlineFlag, MdOutlineList, MdOutlinePersonOff, MdOutlinePolicy, MdOutlineRoute } from 'react-icons/md'
import { RiMoneyDollarCircleLine } from 'react-icons/ri'
import { TbSettings } from 'react-icons/tb'
import { useParams, useSearchParams } from 'react-router-dom'
import AdditionalFieldsSettings from './AdditionalFieldsSettings'
import FlagsSettings from './FlagsSettings'
import FunnelsSettings from './FunnelsSettings'
import OriginsSettings from './OriginsSettings'
import ProductsSettings from './ProductsSettings'
import ReasonsDiscardSettings from './ReasonsDiscardSettings'
import ChatFlagsSettings from './ChatFlagsSettings'
import CampaignLimitSettings from './CampaignLimitSettings'
import GovernanceSettings from './GovernanceSettings'

const Settings = () => {
    const { account_id } = useParams()
    const [searchParams] = useSearchParams()
    const [activeOption, setActiveOption] = useState(searchParams.get("section") === "campaign-limits" ? 9 : (searchParams.get("section") === "governance" ? 8 : 1))

    const optionsList = [
        { id: 1, name: "Cadastro de Produtos", description: "Produtos usados em vendas, propostas e relatórios.", icon: <MdOutlineList />, },
        { id: 2, name: "Motivos de Descartes", description: "Padronize os motivos de perda e descarte de leads.", icon: <MdOutlinePersonOff /> },
        { id: 3, name: "Origens", description: "Organize os canais de entrada e aquisição.", icon: <MdOutlineRoute /> },
        { id: 4, name: "Campos Adicionais", description: "Crie campos extras para qualificação e cadastro.", icon: <LuTextCursorInput /> },
        { id: 5, name: "Etiquetas", description: "Classifique leads e oportunidades com marcações visuais.", icon: <MdOutlineFlag /> },
        { id: 6, name: "Etiquetas do Chat", description: "Defina etiquetas para atendimento e conversas.", icon: <MdOutlineFlag /> },
        { id: 7, name: "Funis", description: "Configure pipelines e etapas comerciais.", icon: <BsFunnel /> },
        { id: 8, name: "Governança do CRM", description: "Defina políticas de dados, jornada, atribuição e auditoria.", icon: <MdOutlinePolicy /> },
        { id: 9, name: "Limites de Campanhas", description: "Controle o custo mensal estimado dos disparos WhatsApp API.", icon: <RiMoneyDollarCircleLine /> },
    ]

    const active = optionsList.find(option => option.id === activeOption) || optionsList[0]

    return (
        <div className={styles.content}>
            <div className={styles.card}>
                <div className={styles.left}>
                    <div className={styles.header}>
                        <div className={styles.headerIcon}>
                            <TbSettings />
                        </div>
                        <div>
                            <span>Configurações</span>
                            <p>Ajustes operacionais da conta</p>
                        </div>
                    </div>
                    <div className={styles.body}>
                        <div className={styles.options}>
                            {optionsList && optionsList.map(option => (
                                <div className={`${styles.option} ${activeOption === option.id ? styles.active : ''}`} key={option.id} onClick={() => setActiveOption(option.id)}>
                                    <div className={styles.optionIcon}>{option.icon}</div>
                                    <div>
                                        <span>{option.name}</span>
                                        <small>{option.description}</small>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
                <div className={styles.right}>
                    <div className={styles.panelHeader}>
                        <div className={styles.panelIcon}>{active.icon}</div>
                        <div>
                            <span className={styles.eyebrow}>Módulo</span>
                            <h1>{active.name}</h1>
                            <p>{active.description}</p>
                        </div>
                    </div>
                    <div className={styles.body}>
                        {activeOption === 1 && <ProductsSettings account_id={account_id} />}
                        {activeOption === 2 && <ReasonsDiscardSettings account_id={account_id} />}
                        {activeOption === 3 && <OriginsSettings account_id={account_id} />}
                        {activeOption === 4 && <AdditionalFieldsSettings account_id={account_id} />}
                        {activeOption === 5 && <FlagsSettings account_id={account_id} />}
                        {activeOption === 6 && <ChatFlagsSettings account_id={account_id} />}
                        {activeOption === 7 && <FunnelsSettings account_id={account_id} />}
                        {activeOption === 8 && <GovernanceSettings account_id={account_id} />}
                        {activeOption === 9 && <CampaignLimitSettings account_id={account_id} />}
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Settings
